import React, { useEffect, useState } from "react";
import "./ZoomImage.css";

const ZoomImage = ({ imageUrl, tileRect, onClose, comment }) => {
    const [open, setOpen] = useState(false);
    // État pour masquer le titre quand on clique
    const [hideTitle, setHideTitle] = useState(false);

    useEffect(() => {
        requestAnimationFrame(() => {
            setOpen(true);
        });
    }, []);

    const handleClick = () => {
        // On masque immédiatement le titre
        setHideTitle(true);
        // On lance l'animation de fermeture
        setOpen(false);
        setTimeout(() => onClose(), 800);
    };

    // Style initial correspondant à la tuile
    const startStyle = {
        top: tileRect.top - 40 + "px",
        left: tileRect.left + "px",
        width: tileRect.width + "px",
        height: tileRect.height + "px",
    };

    return (
        <div className="zoom-image-wrapper" onClick={handleClick}>
            <div
                className={`zoom-image ${open ? "zoom-image-open" : ""}`}
                style={{
                    ...startStyle,
                    position: "absolute",
                }}
            >
                <div
                    style={{
                        position: "relative",
                        width: "100%",
                        height: "100%",
                    }}
                >
                    {/* L'image en plein */}
                    <img
                        src={imageUrl}
                        alt="zoomed"
                        style={{
                            marginTop: 70,
                            height: "80%",
                            objectFit: "cover",
                        }}
                    />

                    {/* Affichage conditionnel du titre */}
                    {!hideTitle && (
                        <div
                            style={{
                                position: "absolute",
                                top: "20px",
                                left: "50%",
                                transform: "translateX(-50%)",
                                backgroundColor: "#fff",
                                padding: "6px 12px",
                                borderRadius: "4px",
                                boxShadow: "0 2px 5px rgba(0,0,0,0.3)",
                            }}
                        >
                            <h2
                                style={{
                                    margin: 0,
                                    color: "#000",
                                    fontSize: "28px",
                                }}
                            >
                                {comment}
                            </h2>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ZoomImage;
